import { HealthDataSource } from '../Enums/HealthDataSource.enum';

export default function useHealthDataSource() {
	const healthDataSourceKeyMap: any = {
		appleHealth: HealthDataSource.APPLE_HEALTH,
		googleFit: HealthDataSource.GOOGLE_FIT,
		questionnaire: HealthDataSource.QUESTIONNAIRE,
		bioScan: HealthDataSource.BIO_SCAN,
		ingestion: HealthDataSource.INGESTION,
	};

	const mapSources = (sources: any) => {
		const source: string[] = [];
		Object.keys(sources).map((item, index) => {
			if (sources[item]) {
				source.push(healthDataSourceKeyMap[item]);
			}
		});
		return source;
	};

	return { mapSources };
}
